import React from 'react';
import './MeowSelector.css';

function MeowSelector({ selectedMeow, onSelectMeow }) {
  const meows = [
    { id: '01', name: '喵喵琴-1', emoji: '🐱' },
    { id: '02', name: '喵喵琴-2', emoji: '🐱' },
    { id: '03', name: '喵喵琴-3', emoji: '🐱' },
    { id: '04', name: '喵喵琴-4', emoji: '🐱' },
    { id: '05', name: '喵喵琴-5', emoji: '🐱' },
    { id: '06', name: '喵喵琴-6', emoji: '🐱' },
    { id: '07', name: '喵喵琴-7', emoji: '🐱' },
    { id: '08', name: '喵喵琴-8', emoji: '🐱' },
  ];

  return (
    <div className="meow-selector">
      <div className="meow-selector-label">选择喵喵：</div>
      <div className="meow-list">
        {meows.map((meow) => (
          <button
            key={meow.id}
            className={`meow-item ${selectedMeow === meow.id ? 'selected' : ''}`}
            onClick={() => onSelectMeow(meow.id)}
            title={meow.name}
          >
            <span className="meow-emoji">{meow.emoji}</span>
            <span className="meow-number">{meow.id.slice(1)}</span>
          </button>
        ))}
      </div>
    </div>
  );
}

export default MeowSelector;
